import config from '../config'

export const imgurl = (uri?: string) => uri ? `${config.API_URL}${uri}` : undefined
